import React from 'react';
import { IoIosPersonAdd } from 'react-icons/io';
import { BsPeopleFill } from 'react-icons/bs';
import SelectionModal from '../Modals/SelectionModal';
import '../dashboardStyle.css';
import { withSnackbar } from '../../../utils/SnackbarHOC';
import { IoArchiveSharp } from 'react-icons/io5';
import { getUserData } from '../../../utils/FunctionHelpers';
import ChooseSelectionModal from '../Modals/ChooseSelectionModal';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import Mail from '@mui/icons-material/Mail';
import MoveToInbox from '@mui/icons-material/MoveToInbox';
import { setToggleMailing } from '../../../redux/toggle/actions/toggleActions';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Menu, MenuItem, ListItemIcon, ListItemText, Box, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import AddRoundedIcon from '@mui/icons-material/AddRounded';

const OpsButton = styled(Button)(() => ({
  borderRadius: 10,
  padding: '7px 16px',
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '1rem',
  background: 'linear-gradient(135deg, #0556a4, #03407b)',
  color: '#fff',
  boxShadow: '0 2px 8px rgba(99,102,241,0.3)',
  transition: 'all 0.18s ease',
  gap: 6,
  '&:hover': {
    background: 'linear-gradient(135deg, #03407b, #022d68)',
    boxShadow: '0 4px 12px rgba(99,102,241,0.4)',
    transform: 'translateY(-1px)',
  },
  '&:active': { transform: 'translateY(0)' },
}));

const StyledMenu = styled(Menu)(() => ({
  '& .MuiPaper-root': {
    borderRadius: 12,
    border: '1px solid #e2e8f0',
    boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
    minWidth: 220,
    marginTop: 6,
  },
}));

const StyledMenuItem = styled(MenuItem)(() => ({
  margin: '2px 8px',
  borderRadius: 8,
  fontSize: '1rem',
  gap: 4,
  '&:hover': { background: '#f1f5f9' },
  '&.Mui-disabled': { opacity: 0.4 },
}));

const ButtonList = ({ history, selectedCandidats, snackbarShowMessage, loading }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const dispatch = useDispatch();
  const selectedCandidatForSelection = useSelector(
    (state) => state.candidats.candidatsSelectedForSelection
  );

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const selectionModalProps = {
    selectedCandidats,
    closeList: handleClose,
    isModify: false,
    snackbarShowMessage,
    history,
  };

  const handleOperation = (action) => {
    switch (action) {
      case 'candidat':
        history.push({ pathname: '/candidats/add' });
        break;
      case 'societe':
        history.push({ pathname: '/societe/add' });
        break;
      default:
        break;
    }
  };

  return (
    <Box>
      <OpsButton onClick={handleClick} startIcon={<AddRoundedIcon sx={{ fontSize: 18 }} />}>
        Opérations
      </OpsButton>

      <StyledMenu
        id="ops-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        transformOrigin={{ horizontal: 'left', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      >
        <StyledMenuItem onClick={() => handleOperation('candidat')}>
          <ListItemIcon sx={{ minWidth: 32 }}>
            <IoIosPersonAdd size={18} style={{ color: '#03407b' }} />
          </ListItemIcon>
          <ListItemText primary="Ajouter un candidat" primaryTypographyProps={{ fontSize: '1rem' }} />
        </StyledMenuItem>

        <StyledMenuItem onClick={() => handleOperation('societe')}>
          <ListItemIcon sx={{ minWidth: 32 }}>
            <BsPeopleFill size={16} style={{ color: '#0ea5e9' }} />
          </ListItemIcon>
          <ListItemText primary="Ajouter une société" primaryTypographyProps={{ fontSize: '1rem' }} />
        </StyledMenuItem>

        <StyledMenuItem
          onClick={() => dispatch(setToggleMailing(true))}
          disabled={selectedCandidatForSelection.length === 0}
        >
          <ListItemIcon sx={{ minWidth: 32 }}>
            <Mail fontSize="small" sx={{ color: '#10b981' }} />
          </ListItemIcon>
          <ListItemText primary="Emailing" primaryTypographyProps={{ fontSize: '1rem' }} />
        </StyledMenuItem>

        {getUserData().role.includes('ROLE_DIRECTION') && (
          <>
            <Divider sx={{ my: 0.5, borderColor: '#f1f5f9' }} />
            <SelectionModal {...selectionModalProps}>
              {(handleOpen) => (
                <StyledMenuItem onClick={handleOpen} disabled={!(selectedCandidats.length > 0)}>
                  <ListItemIcon sx={{ minWidth: 32 }}>
                    <IoArchiveSharp size={16} style={{ color: '#f59e0b' }} />
                  </ListItemIcon>
                  <ListItemText primary="Enregistrer la sélection" primaryTypographyProps={{ fontSize: '1rem' }} />
                </StyledMenuItem>
              )}
            </SelectionModal>

            <ChooseSelectionModal {...selectionModalProps}>
              {(handleOpen) => (
                <StyledMenuItem onClick={handleOpen} disabled={!(selectedCandidats.length > 0)}>
                  <ListItemIcon sx={{ minWidth: 32 }}>
                    <MoveToInbox fontSize="small" sx={{ color: '#8b5cf6' }} />
                  </ListItemIcon>
                  <ListItemText primary="Ajouter à une sélection" primaryTypographyProps={{ fontSize: '1rem' }} />
                </StyledMenuItem>
              )}
            </ChooseSelectionModal>
          </>
        )}
      </StyledMenu>
    </Box>
  );
};

export default withSnackbar(ButtonList);
